export const messages = {
  en: {
    discountType: {
      search: {
        title: 'Search Conditions',
        applyType: 'Please enter type code',
        typeName: 'Please enter type name'
      },
      list: {
        title: 'Discount Types'
      },
      table: {
        applyType: 'Type Code',
        typeName: 'Type Name',
        typeDesc: 'Type Description',
        createTime: 'Create Time'
      },
      form: {
        applyType: 'Type Code',
        typeName: 'Type Name',
        typeNamePlaceholder: 'Required, please enter type name',
        typeDesc: 'Type Description',
        typeDescPlaceholder: 'Optional, please enter type description'
      },
      validate: {
        applyTypeRequired: 'Type code is required',
        typeNameRequired: 'Type name is required',
        typeNameMaxLength: 'Type name max length is 64',
        typeDescMaxLength: 'Type description max length is 512'
      },
      add: {
        title: 'Add Discount Type',
        success: 'Add success'
      },
      edit: {
        title: 'Edit Discount Type',
        success: 'Edit success'
      },
      delete: {
        title: 'Delete Confirmation',
        confirmText: 'Are you sure to delete this discount type?',
        success: 'Delete success'
      },
      fetchError: 'Failed to fetch discount types'
    },
  },
  zh: {
    discountType: {
      search: {
        title: '查询条件',
        applyType: '请输入类型编码',
        typeName: '请输入类型名称'
      },
      list: {
        title: '优惠类型'
      },
      table: {
        applyType: '类型编码',
        typeName: '类型名称',
        typeDesc: '类型描述',
        createTime: '创建时间'
      },
      form: {
        applyType: '类型编码',
        typeName: '类型名称',
        typeNamePlaceholder: '必填，请填写类型名称',
        typeDesc: '类型描述',
        typeDescPlaceholder: '选填，请填写类型描述'
      },
      validate: {
        applyTypeRequired: '类型编码不能为空',
        typeNameRequired: '类型名称不能为空',
        typeNameMaxLength: '类型名称最大长度64',
        typeDescMaxLength: '类型描述最大长度512'
      },
      add: {
        title: '添加优惠类型',
        success: '添加成功'
      },
      edit: {
        title: '修改优惠类型',
        success: '修改成功'
      },
      delete: {
        title: '删除确认',
        confirmText: '确定删除该优惠类型吗？',
        success: '删除成功'
      },
fetchError: '获取优惠类型失败'
    },
  },
  'zh-TW': {
    discountType: {
      search: {
        title: '查詢條件',
        applyType: '請輸入類型編碼',
        typeName: '請輸入類型名稱'
      },
      list: {
        title: '優惠類型'
      },
      table: {
        applyType: '類型編碼',
        typeName: '類型名稱',
        typeDesc: '類型描述',
        createTime: '創建時間'
      },
      form: {
        applyType: '類型編碼',
        typeName: '類型名稱',
        typeNamePlaceholder: '必填，請填寫類型名稱',
        typeDesc: '類型描述',
        typeDescPlaceholder: '選填，請填寫類型描述'
      },
      validate: {
        applyTypeRequired: '類型編碼不能為空',
        typeNameRequired: '類型名稱不能為空',
        typeNameMaxLength: '類型名稱最大長度64',
        typeDescMaxLength: '類型描述最大長度512'
      },
      add: {
        title: '添加優惠類型',
        success: '添加成功'
      },
      edit: {
        title: '修改優惠類型',
        success: '修改成功'
      },
      delete: {
        title: '刪除確認',
        confirmText: '確定刪除該優惠類型嗎？',
        success: '刪除成功'
      },
      fetchError: '獲取優惠類型失敗'
    },
  }
}